module.exports = __webpack_public_path__ + "static/zyppyslandingpage3-f30e3098e710c821a078ce573367aeb5.jpg";